import { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import BienContext from '@/features/biens/BienContext'
import { fetchRents, setFilters } from '@/features/quittances/quittancesSlice'
import { DownloadButton, Pagination, Spinner } from '@/components/ui'
import { formatPeriod } from '@/utils/formatters'
import { useUrlFilters } from '@/hooks/useUrlFilters'

const QuittancesLocataire = () => {
  const dispatch = useDispatch()
  const { bien } = useContext(BienContext)
  const location = bien?.location

  const quittances = useSelector((state) => state.quittances.items)
  const filters = useSelector((state) => state.quittances.filters)
  const pagination = useSelector((state) => state.quittances.pagination)
  const isLoading = useSelector((state) => state.quittances.loadingStatus.fetchList)

  useUrlFilters({
    setFiltersAction: setFilters,
    fetchAction: (params) => {
      if(location?.id) { return fetchRents({ location_id: location?.id, ...params }) }
      return () => {}
    },
    filters,
    allowedParams: ['page', 'limit'],
    updateUrlParams: false // Pas besoin de mettre à jour l'URL pour l'extranet
  })

  useEffect(() => {
    if(location?.id) {
      dispatch(fetchRents({ location_id: location?.id}))
    }
  }, [location?.id])

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  }

  const hasData = quittances.length > 0

  return (
    <div className='overflow-hidden'>
      <h3 className="text-md font-semibold mb-2">Vos quittances</h3>
      <div className="w-full bg-primary-100 p-4 rounded-none space-y-4">
        { isLoading && <Spinner color="primary" />}
        { !isLoading && <>
          { !hasData ? <p>Les quittances de loyer seront disponibles prochainement.</p> :
            <div className="grid grid-cols-1 md:grid-cols-2">
              { quittances.map( (quittance, index) => (
                <div data-id={quittance.id} data-model="quittance" key={index} className="flex space-x-2 hover:bg-primary-200 p-2 rounded-sm">
                  { quittance.pdf_file && <DownloadButton file={quittance.pdf_file} title={`la quittance de ${formatPeriod(quittance.year, quittance.month)}`}/> }
                  <div className="flex flex-col">
                    <div className="flex">
                      <span>Quittance de {formatPeriod(quittance.year, quittance.month)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          }
          { pagination.totalPages > 1 && (
            <Pagination 
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>}
      </div>
    </div>
  )
}

export default QuittancesLocataire